import { compile } from 'path-to-regexp';

var has = Object.prototype.hasOwnProperty;
var qs = function qs(obj, prefix) {
  var pairs = [];
  for (var key in obj) {
    if (!has.call(obj, key)) {
      continue;
    }
    var value = obj[key];
    var enkey = encodeURIComponent(key);
    var pair = void 0;
    if (typeof value === 'object') {
      pair = qs(value, prefix ? prefix + '[' + enkey + ']' : enkey);
    } else {
      pair = (prefix ? prefix + '[' + enkey + ']' : enkey) + '=' + encodeURIComponent(value);
    }
    pairs.push(pair);
  }
  return pairs.join('&');
};

var CACHE_LIMIT = 10000;
var makeCache = function makeCache() {
  var cache = {};
  var count = 0;
  return {
    get: function get(key) {
      return cache[key] && cache[key];
    },
    set: function set(key, data) {
      if (count < CACHE_LIMIT) {
        cache[key] = data;
        count++;
      }
      return data;
    }
  };
};
var cache = /*#__PURE__*/makeCache();
var makeCompilePath = function makeCompilePath(path) {
  if (cache.get(path)) {
    return cache.get(path);
  }
  var generator = compile(path);
  return cache.set(path, generator);
};
var makeRoutePath = function makeRoutePath(path, qsFunc) {
  if (typeof path !== 'string') throw new Error('Please path string as a path');
  var qsStringify = qsFunc != null ? qsFunc : qs;
  var fn = function fn(params, query) {
    if (query === void 0) {
      query = {};
    }
    // Make query string
    var queryString = Object.keys(query).length > 0 ? '?' + qsStringify(query) : '';
    // Exclude unnecessary compile
    if (!params || path === '/') {
      return path + queryString;
    }
    var compilePath = makeCompilePath(path);
    return compilePath(params) + queryString;
  };
  // Provide path to make access without function call
  fn.PATH = path;
  return fn;
};

export { makeRoutePath };
